import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Ribbon } from "@/components/Ribbon";
import { Manifesto } from "@/components/Manifesto";
import { JobCategories } from "@/components/JobCategories";
import { Stats } from "@/components/Stats";
import { EnquirySection } from "@/components/EnquirySection";
import { AboutContact } from "@/components/AboutContact";
import { Footer } from "@/components/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        window.__lenis = lenis;
        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App grain relative bg-[#050B14] min-h-screen">
            <Header />
            <main>
                <Hero />
                <Ribbon />
                <Stats />
                <Manifesto />
                <JobCategories />
                <EnquirySection />
                <AboutContact />
            </main>
            <Footer />
            <Toaster position="top-center" theme="dark" richColors />
        </div>
    );
}

export default App;
